export default __webpack_public_path__ + "static/media/weaving.ccd9cb6b.png";